'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _UISelectableBox = require('./UISelectableBox');

var _UISelectableBox2 = _interopRequireDefault(_UISelectableBox);

var _tshirtSize = require('../utils/propTypes/tshirtSize');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SIZE_CLASSES = {
  auto: 'private-selectable-button--auto',
  small: 'private-selectable-button--small',
  large: 'private-selectable-button--large'
};

var UISelectableButton = _react2.default.createClass({
  displayName: 'UISelectableButton',

  propTypes: {
    'aria-checked': _react.PropTypes.bool,
    block: _react.PropTypes.bool,
    children: _react.PropTypes.node,
    disabled: _react.PropTypes.bool.isRequired,
    name: _react.PropTypes.string,
    onSelectedChange: _react.PropTypes.func,
    readOnly: _react.PropTypes.bool,
    selected: _react.PropTypes.bool,
    showCheckbox: _react.PropTypes.bool,
    size: _react.PropTypes.oneOfType([(0, _tshirtSize.propTypeForSizes)(['sm', 'lg']), _react.PropTypes.oneOf(['auto'])]).isRequired,
    textLabel: _react.PropTypes.node,
    truncatable: _react.PropTypes.bool,
    type: _react.PropTypes.oneOf(['default', 'checkbox', 'radio']).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      disabled: false,
      readOnly: false,
      selected: false,
      size: 'small',
      truncatable: true,
      type: 'default'
    };
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        name = _props.name,
        selected = _props.selected,
        showCheckbox = _props.showCheckbox,
        size = _props.size,
        textLabel = _props.textLabel,
        type = _props.type,
        truncatable = _props.truncatable,
        rest = _objectWithoutProperties(_props, ['children', 'className', 'name', 'selected', 'showCheckbox', 'size', 'textLabel', 'type', 'truncatable']);

    if (textLabel == null && children == null) {
      _devLogger2.default.warn({
        message: 'UISelectableButton: Should provide either textLabel or children.',
        key: 'UISelectableButton: content'
      });
    }

    if (showCheckbox) {
      _devLogger2.default.warn({
        message: 'UISelectableButton: The showCheckbox prop is deprecated, please use the `type` prop instead instead.',
        key: 'UISelectableButton: use showCheckbox error'
      });
    }

    if (type === 'radio' && !name) {
      _devLogger2.default.warn({
        message: 'UISelectableButton: If type is set to radio you must provide a name',
        key: 'UISelectableButton: no name value'
      });
    }

    var longhandSize = (0, _tshirtSize.toLonghandSize)(size);

    var maybeSelectionMarkClass = longhandSize === 'large' ? '' : 'private-selectable-button__label--' + (type === 'default' ? 'no-selection-mark' : 'selection-mark');
    var computedSelectionMarkLocation = void 0;
    if (type !== 'default' || showCheckbox) {
      computedSelectionMarkLocation = longhandSize === 'large' ? 'top-right' : 'left';
    }

    return _react2.default.createElement(
      _UISelectableBox2.default,
      _extends({
        className: (0, _classNames2.default)('private-selectable-button', SIZE_CLASSES[longhandSize], className),
        innerClassName: (0, _classNames2.default)('private-selectable-button__inner', {
          'private-selectable-button__inner--truncatable': truncatable
        }),
        name: type === 'default' ? undefined : name,
        padded: false,
        selected: selected,
        selectionMarkLocation: computedSelectionMarkLocation,
        type: showCheckbox ? 'checkbox' : type
      }, rest),
      children,
      textLabel ? _react2.default.createElement(
        'span',
        {
          className: (0, _classNames2.default)('private-selectable-button__label', 'private-selectable-button__label--' + (!truncatable ? 'not-' : '') + 'truncatable', maybeSelectionMarkClass)
        },
        textLabel
      ) : null
    );
  }
});

exports.default = (0, _Controllable2.default)(UISelectableButton, ['selected']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/button/UISelectableButton.js
// module id = 307
// module chunks = 3 4 5